import { Environment } from "../enums";

const env = {
  SUPPORT_SOCKET_URL: "https://connect.myhook.site/support",
  // SUPPORT_SOCKET_URL: "http://localhost:8000/support",
  // API_URL: "http://localhost:8000",
  API_URL: "https://connect.myhook.site",
  //
  GHL: {
    CLIENT_ID: "68496e333023a02bae0f1992-mciz3721",
    CLIENT_SECRET: "ff260c80-ddea-46bf-b756-8342240dade7",
    SSO_KEY: "6aef4986-3d15-4c42-a6d7-7aa737160bd2",
    SCOPE:
      "locations.readonly+conversations.readonly+conversations.write+conversations/message.readonly+conversations/message.write+conversations/reports.readonly+conversations/livechat.write+contacts.readonly+contacts.write+workflows.readonly+users.readonly+funnels/redirect.readonly+funnels/page.readonly+funnels/funnel.readonly+funnels/pagecount.readonly+funnels/redirect.write+oauth.write+oauth.readonly+saas/location.read+saas/location.write+businesses.readonly+businesses.write+locations/customValues.readonly+locations/customValues.write+locations/customFields.readonly+locations/tasks.readonly+locations/tasks.write+locations/customFields.write+locations/tags.readonly+locations/tags.write+locations/templates.readonly",
  },
};
if (process.env.REACT_APP_ENV === Environment.DEVELOPMENT) {
  env.API_URL = "https://connect.myhook.site";
}
if (process.env.REACT_APP_ENV === Environment.PRODUCTION) {
  env.API_URL = "https://connect.myhook.site";
}
export default env;
